










































































import Vue from "vue";
import Component from "vue-class-component";
import { Action, Getter } from "vuex-class";
import { localize } from "vee-validate";
import { LoginCard } from "wings-ui-components";
import { UserRoleItem } from "@/store/user_management/roles/types";
import { declOfWords } from "@/utils/notify-utils";
import { ErrorContext } from "@/store/lists/types";

@Component({
  components: { LoginCard },
})
export default class Login extends Vue {
  @Getter("config") config: any;

  @Action("authRequest") authRequest: any;
  @Action("getSystemUsersAction") actionGetSystemUsersAction: any;
  @Action("getUserRoleItem") actionCurrentRole: any;

  private email = "";
  private password = "";
  private isProgress: boolean = false;
  private error: boolean = false;
  private errorMessage = "";
  private InternetExplorer = false;
  logoFull = `${process.env.BASE_URL}img/logo_full.png`

  async doLogin() {
    this.isProgress = true;
    this.error = false;
    try {
      await this.authRequest({
        username: this.email,
        password: this.password,
      });
      let currentRole: UserRoleItem = await this.actionCurrentRole();
      let allowedPages = currentRole.system_pages
        ?.filter((v) => v.allowed === true)
        .map((v) => v.name);
      localStorage.setItem("allowedPages", JSON.stringify(allowedPages));
      this.$router.push(localStorage.getItem("lastUrl") || "/");
      this.actionGetSystemUsersAction();
      this.error = false;
    } catch (e) {
      this.error = true;
      let errorCode = parseInt(e?.response?.data.code ?? 5);
      let errorContext: ErrorContext = e?.response?.data?.errorContext;
      if (errorCode === 5) {
        this.errorMessage = this.$t("errors.invalid_credentials").toString();
      } else if (errorCode === 6) {
        this.errorMessage = this.$t("errors.user_locked").toString();
      } else if (errorCode === 18) {
        let symbols: string = declOfWords(
          parseInt(errorContext.remainingLockTime),
          "minutes"
        );
        this.errorMessage = `${this.$t("errors.user_temporary_locked")}
        ${errorContext.remainingLockTime} ${symbols}`;
      } else if (errorCode === 19) {
        let symbols: string = declOfWords(
          parseInt(errorContext.systemBlockingTimeout),
          "days"
        );
        this.errorMessage = `${this.$t("errors.user_locked_by_system", [
          errorContext.systemBlockingTimeout + " " + symbols,
        ])}`;
      } else if (errorCode === 27) {
        this.errorMessage = this.$t("errors.active_directory_not_set").toString();
      } else if (errorCode === 28) {
        this.errorMessage = this.$t("errors.user_already_in_system").toString();
      } else if (errorCode === 42) {
        this.errorMessage = this.$t("errors.active_directory_server_unavaible").toString();
      } else {
        this.errorMessage = this.$t("errors.invalid_credentials").toString();
      }
    } finally {
      this.isProgress = false;
    }
  }

  setLocale($event: string) {
    this.$i18n.locale = $event;
    localize($event);
    localStorage.setItem("locale", $event);
    document.title = this.$store.getters.config.company + '. ' + this.$t('auth.title')
  }

  browserLanguage(): void {
    if (!localStorage.getItem("locale")) {
      let language = window.navigator ? window.navigator.language : "ru";
      language = language.substr(0, 2).toLowerCase();
      localStorage.setItem("locale", language);
      this.$i18n.locale = language;
    }
    if (this.config.only_english) {
      this.setLocale('en')
    }
  }

  created() {
    this.browserLanguage();
    const userAgent = navigator.userAgent.toLowerCase();
    if (
      (/mozilla/.test(userAgent) &&
        !/firefox/.test(userAgent) &&
        !/chrome/.test(userAgent) &&
        !/safari/.test(userAgent) &&
        !/opera/.test(userAgent)) ||
      /msie/.test(userAgent)
    )
      this.InternetExplorer = true;
  }
}
